import { useHostElement } from "#ce/composables/useHostElement";

/**
 * Dispatches an event on the host element the way a native control reports one: a `CustomEvent`
 * carrying the payload in `detail`, bubbling through the light DOM so delegated ancestor listeners
 * hear it, and stopping at any enclosing shadow boundary (`composed: false`) so an sp-* element
 * nested inside another's shadow root stays contained.
 *
 * Vue's custom-element `emit` dispatches non-bubbling events, which delegated form tracking never
 * sees — use this for the host's `input`/`change`; Vue `emit` stays fine for element-specific
 * events consumers bind directly (`update-checked`, `click-append`, …).
 *
 * @returns {{ emitBubbling: (type: string, ...args: any[]) => void }}
 */
export function useHostEmit() {
  const host = useHostElement();

  function emitBubbling(type, ...args) {
    host?.dispatchEvent(new CustomEvent(type, { detail: args, bubbles: true, composed: false }));
  }

  return { emitBubbling };
}
